import { lazyLoad } from 'utils/loadable';

export const ChangePassword = lazyLoad(
  () => import('./changePassword.page'),
  (module) => module.ChangePassword
);
